import React from 'react';
import Card from '@material-ui/core/Card';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useQuery,  Loading, Error  } from 'react-admin';
import jwt_decode from 'jwt-decode'


import CardIcon from '../controls/CardIcon'

const useStyles = makeStyles({
    main: {
        flex: '1',
        marginLeft: '8px',
        marginTop: 10,
        marginBottom: 10,
    },
    card: {
        overflow: 'inherit',
        textAlign: 'center',
        padding: 16,
        minHeight: 15,
    },
    title: {
        fontSize: 16,
    }
});





const GetInstAlert = ({code}) => {
    const classes = useStyles();
    //console.log(code)
    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'getinstalert',
        payload:   {id: code} 
    });

    if (loading) return '';
    //if (error) {console.log(error)};
    if (!data || !data.id) return null;
    //console.log(data)

    if(data.id > 30) return null;
    //const color = data.results < 0 ? 'red': 'orange';
    return (data.id < 0 ? <font color = "red">(Overdue)</font> :
            <font color = 'orange'>(Due in {data.id} days)</font>
    );
};

export default GetInstAlert;